import { Component, effect, HostListener, Injector, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { localStorageService } from '../services/localstorage.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EConsentModalComponent } from '../shared/e-consent-modal/e-consent-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SharedService } from 'src/app/services/shared.service';
import { Subscription } from 'rxjs';
import { MainService } from '../services/main.service';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, OnDestroy {
  private hideSideMenuUrls: string[] = ['debt-recuvery', 'single-debt-recuvery', 'multi-debt-recuvery', 'e-consent'];
  private hideMainHeaderUrls: string[] = ['debt-recuvery', 'single-debt-recuvery', 'multi-debt-recuvery', 'e-consent'];
  showSideMenu: boolean = true;
  showMainHeader: boolean = true;
  chatUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.chatIframeUrl);
  showChat: boolean = false;
  user_profile: any;
  isConnected: boolean = false;
  iscommercial: any;
  bsModalRef: BsModalRef | undefined;
  private eConsentOpened = false;
  private routerSub: Subscription | undefined;
  private modalHiddenSub: Subscription | undefined;
  private modalTimeout: any;

  constructor(private _router: Router,private _local : localStorageService,private sanitizer: DomSanitizer, private modalService: BsModalService, private _shared: SharedService, public main: MainService, private injector: Injector) { }

  ngOnInit(): void {
    // this.iscommercial = this.main.iscommercial;
    this.routerSub = this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.updateUI(event.url);
        // e-consent is mandatory: re-check on every navigation so the modal comes
        // back if the user opened the flow but left it without completing it.
        this.checkEConsent(event.urlAfterRedirects || event.url);
      }
      if (
        event instanceof NavigationStart &&
        event.url.includes('e-consent')
      ) {
        this.closeEConsentModal();
      }
    });

    // Check the initial URL on component initialization
    this.updateUI(this._router.url);

    this.user_profile = this._local.customGetItem('userProfileData');
    console.log(this.user_profile,"user_profile----");
    effect(() => {
      const res: any = this._shared.doctorProfile();
      this.user_profile = res;
      this.checkEConsent(this._router.url);
    }, { injector: this.injector, allowSignalWrites: true })

  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    if (this.modalHiddenSub) {
      this.modalHiddenSub.unsubscribe();
    }
    if (this.modalTimeout) {
      clearTimeout(this.modalTimeout);
    }
  }

  private updateUI(url: string): void {
    // Add and Hide Sidebar for e-consent 
    this.hideSideMenuUrls = this.hideSideMenuUrls.filter(u => u !== 'e-consent');
    this.hideMainHeaderUrls = this.hideMainHeaderUrls.filter(u => u !== 'e-consent');

    // Add ONLY for app/e-consent
    if (url.includes('app/e-consent')) {
      this.hideSideMenuUrls.push('e-consent');
      this.hideMainHeaderUrls.push('e-consent');
    }

    this.showSideMenu = true;
    // this.showSideMenu = !this.hideSideMenuUrls.some(route => url.includes(route));


    this.showMainHeader = !this.hideMainHeaderUrls.some(route => url.includes(route));
  }

  show_chat() {
    this.showChat = !this.showChat;  
    if(this.showChat && !this.isConnected) {
      this.chatUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.chatIframeUrl);
      this.isConnected = true;
      const iframe = document.getElementById('chatbotIframe') as HTMLIFrameElement;
      // console.log(iframe,"iframe----");
      let access_token = this._local.customGetItem('token');      
      iframe.onload = () => {
        iframe.contentWindow?.postMessage(
          { userId: this.user_profile.doctor_id, user_type: 1,access_token: access_token, ticketId: this.user_profile.chat_tiket_id },
          environment.chatIframeUrl // Ensure this matches the iframe's origin
        );
      };
    } else {
      this.chatUrl = '';
    }
  }

  // Single entry point that decides whether the mandatory e-consent modal must be shown.
  private checkEConsent(url: string): void {
    if (this.eConsentOpened) return;                      // already open / opening
    if (!url || url.includes('e-consent')) return;        // user is inside the flow
    if (this.hideEConsent()) return;
    if (!this.isEConsentPending()) return;
    this.eConsentModal();
  }

  // Consent is still pending until the user actually submits it.
  private isEConsentPending(): boolean {
    // E-consent applies only to consumer debt: skip it for commercial-only users
    // and for both-type users currently operating on commercial debt.
    const eConsentApplicable =
      this.user_profile?.allowed_debt_type != 2 &&
      (this.user_profile?.allowed_debt_type != 3 || this.user_profile?.doctor_debt_type != 2);
    if (!eConsentApplicable) return false;
    // customGetItem() returns null for a stored 0, so a truthy value means consent was submitted.
    const stored = this._local.customGetItem('e_consent_status');
    const status = stored !== null && stored !== undefined && stored !== ''
      ? stored
      : this.user_profile?.e_consent_status;
    if (status === null || status === undefined || status === '') return false;
    return status == 0;
  }

  private closeEConsentModal(): void {
    if (this.modalTimeout) {
      clearTimeout(this.modalTimeout);
      this.modalTimeout = null;
    }
    this.bsModalRef?.hide();
    this.eConsentOpened = false;
  }

  eConsentModal() {
    if (this.hideEConsent()) return;

    this.eConsentOpened = true;                     // lock while the open is pending
    if (this.modalTimeout) {
      clearTimeout(this.modalTimeout);
    }

   this.modalTimeout = setTimeout(() => {
     // Optional: check if modal is already open by checking modalsCount
     if (this.hideEConsent() || this.modalService.getModalsCount() > 0) {
       this.eConsentOpened = false;   // release the lock so it can be retried later
       return; // Prevent opening multiple modals if one is already open
     }
     
     this.bsModalRef = this.modalService.show(EConsentModalComponent, {
      initialState: {
        modalType: this._shared.modalTypes.verifyDebt
      },
      class: 'modal-dialog-centered',
      backdrop: 'static',
      keyboard: false
    });

    // Once the modal is dismissed (e.g. "Get Started"), release the lock so the
    // modal is shown again on the next navigation while consent is still pending.
    this.modalHiddenSub?.unsubscribe();
    this.modalHiddenSub = this.bsModalRef.onHidden?.subscribe(() => {
      this.eConsentOpened = false;
    });
   }, 1500);
  }
  
  hideEConsent(): boolean {
    return window.location.pathname.includes('e-consent')
  }

}
